module.exports = __webpack_public_path__ + "static/img/107.0ef19bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201224/107.jpg
// module id = PD0R
// module chunks = 0